/* eslint-disable import/order */
import { DashboardBackgroundScripts } from '@jira/platform__layouts-background-scripts-layout/src/ui/dashboard/index.tsx';
import { DASHBOARD } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { dashboardViewEmbedRoute } from '@jira/router-routes__dashboard-routes/src/dashboardViewEmbedRoute.tsx';
import {
	DashboardViewEmbedPage,
	dashboardResources,
	LazyDashboardViewEmbed,
	LazyForPaintBackgroundScripts,
	LazyForPaintConnectJsApi,
} from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const dashboardViewEmbedRouteEntry: Route = createEntry(dashboardViewEmbedRoute, () => ({
	group: 'dashboard',
	// eslint-disable-next-line no-restricted-syntax
	component: DashboardViewEmbedPage,

	layout: createLayout({
		globalComponents: [DashboardBackgroundScripts],
		isChromeless: true,
	}),

	resources: [...jiraSpaResources(), ...dashboardResources()],
	forPaint: [LazyDashboardViewEmbed, LazyForPaintBackgroundScripts, LazyForPaintConnectJsApi],

	meta: {
		capability: DASHBOARD,
	},

	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,

	wrmMode: 'early',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
